/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 10:34:58
 */
import { createApp, onMounted } from 'vue'
import { createPinia } from 'pinia';
import './style.css'
import App from './App.vue'
import AntdDesignVue from 'ant-design-vue'
import * as AntIcons from '@ant-design/icons-vue'
import 'ant-design-vue/dist/reset.css';
import Router from './router.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '@/assets/font/font.css'
import i18n from '@/i18n/index.js';
import directive from './directive/index'; // 统一自定义指令入口
import { useStore } from '@/store/index.js';

NProgress.inc(0.4)
NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false})

const app = createApp(App)

const PiniaStore = createPinia()

// 注册组件
Object.keys(AntIcons).forEach(key => {
    app.component(key, AntIcons[key])
})
// 添加到全局
app.config.globalProperties.$antIcons = AntIcons

directive(app)

app.use(PiniaStore)
app.use(Router)
app.use(AntdDesignVue)
app.use(i18n)


app.mount('#app')

Router.beforeEach(async (to, from, next) => {
    // console.log(to, from,' frommmm')
    NProgress.start();
    const store = useStore() 

    if(to.path === '/Login') {
        next() 
    }else if(to.path === '/ForgotPassword') {
        next() 
    }else {
        if(to.meta.requiresAuth && !sessionStorage.getItem('userInfo')) { //未登录
            next({ path: '/Login' })
        }else { // 已登录
            // 检查路由是否在菜单列表中
            let routerList = []
            if(!sessionStorage.getItem('routerList')){
                await store.getMenuList()
                sessionStorage.setItem('routerList', JSON.stringify(store.routerList))
                routerList = store.routerList
            }else{
                routerList = JSON.parse(sessionStorage.getItem('routerList'))
            }   
            // console.log(store.routerList ,'store.routerList ')
            const isAuthorized = routerList.includes(to.path) // 是否授权
            if(to.meta.requiresAuth && !isAuthorized){
                next({ path:'/404' })
            }else{
                next()
            }
            // next()
        }
    }
});
Router.afterEach(() => {
    NProgress.done();
});
